import { createFileRoute } from "@tanstack/react-router";
import TpeParisCrmPage from "@/pages/TpeParisCrmPage";
import fr from "@/i18n/locales/fr.json";

const URL = "https://thiia.app/crm-tpe-paris";
const TITLE = "CRM pour entrepreneurs et TPE à Paris et en Île-de-France | Thiia";
const DESC =
  "CRM et prospection IA pour dirigeants de TPE, indépendants et coachs à Paris et en Île-de-France. Sans abonnement : packs de 29, 59 ou 99 €. Justificatifs Qonto, données en Europe.";

export const Route = createFileRoute("/crm-tpe-paris")({
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESC },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESC },
      { property: "og:type", content: "article" },
      { property: "og:url", content: URL },
      { property: "og:locale", content: "fr_FR" },
      { name: "geo.region", content: "FR-IDF" },
      { name: "geo.placename", content: "Paris" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
    links: [{ rel: "canonical", href: URL }],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "FAQPage",
          inLanguage: "fr",
          url: URL,
          mainEntity: fr.tpeParis.faq.map((f) => ({
            "@type": "Question",
            name: f.q,
            acceptedAnswer: { "@type": "Answer", text: f.a },
          })),
        }),
      },
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          itemListElement: [
            { "@type": "ListItem", position: 1, name: "Thiia", item: "https://thiia.app/" },
            { "@type": "ListItem", position: 2, name: fr.tpeParis.breadcrumb, item: URL },
          ],
        }),
      },
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "SoftwareApplication",
          name: "Thiia",
          url: URL,
          applicationCategory: "BusinessApplication",
          operatingSystem: "Web, iOS, Android",
          areaServed: [
            { "@type": "City", name: "Paris" },
            { "@type": "AdministrativeArea", name: "Île-de-France" },
          ],
          audience: { "@type": "BusinessAudience", audienceType: "Entrepreneurs, dirigeants de TPE, indépendants" },
          offers: [29, 59, 99].map((price) => ({
            "@type": "Offer",
            price: String(price),
            priceCurrency: "EUR",
            category: "Pack de crédits, achat unique sans abonnement",
            url: "https://thiia.app/pricing",
          })),
        }),
      },
    ],
  }),
  component: TpeParisCrmPage,
});
